export const GET_STAKEHOLDER_PROGRESS =
  'pages/member/dashboard/stakeholder/progress-check'

export const GET_STAKEHOLDERS =
  'pages/member/dashboard/stakeholder'

export const POST_SURVEY_INVITE =
  'pages/member/dashboard/stakeholder/invite'
